// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609010614/js/" + chunkId + "." + {"44":"a17f3d4a","225":"5af1ce45","481":"80fa1f23","486":"616f9583","770":"fb7a1831"}[chunkId] + ".0.5804454725182767.chunk.js";
};